import React, { Fragment, useState } from "react";
import {
  Typography,
  TextField,
  Grid,
  Select,
  MenuItem,
  Input,
  InputLabel,
  Button,
  IconButton,
  Modal,
} from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import DeleteIcon from "@mui/icons-material/Delete";

import { makeStyles } from "@mui/styles";

import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

export const OrderlistCategories = (props) => {
  const {
    categorySettings,
    customer,
    orderList,
    orderListSettings,
    handleChangeCategory,
    handleChangeCategorySettings,
    handleClickCategoryAdd,
    onDragEnd,
    onDelete,
    toggleImportingModal,
    toggleExportingModal,
  } = props;

  const classes = useStyles();
  const currentUserStore = useSelector((state) => state.current_user);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState({
    olIndex: null,
    catIndex: null,
  });

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const deleteModalContent = (
    <div className={classes.modal}>
      Are you sure you want to delete this category?
      <br />
      <br />
      <div align="right">
        <Button onClick={() => toggleDeleteModal()}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            onDelete(deleteInfo.olIndex, deleteInfo.catIndex);
            toggleDeleteModal();
          }}
        >
          Confirm
        </Button>
      </div>
    </div>
  );

  return (
    <div className={classes.paper}>
      <Modal open={deleteModal} onClose={toggleDeleteModal}>
        {deleteModalContent}
      </Modal>
      <Grid container spacing={2} alignItems="center">
        {currentUserStore?.is_staff === true && (
          <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
            <Button
              variant="contained"
              color="info"
              onClick={() => toggleImportingModal()}
            >
              Import from CSV
            </Button>
            <Button
              variant="contained"
              color="info"
              onClick={() => toggleExportingModal()}
              style={{ marginLeft: 8 }}
            >
              Export to CSV
            </Button>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: 8,
            padding: 20,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
            marginBottom: 20,
            marginTop: 16,
          }}
          className="new-category"
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={12}>
              <Typography component="h4" style={{ fontWeight: "bold" }}>
                Add new category
              </Typography>
            </Grid>
            <Grid item xs={12} sm={true}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Category Name"
                name="name"
                value={categorySettings && categorySettings.name}
                onChange={handleChangeCategorySettings}
              />
            </Grid>
            {!categorySettings?.company_location && (
              <Grid item xs={12} sm={true}>
                <InputLabel shrink id="company_location_label">
                  Customer Location
                </InputLabel>
                <Select
                  fullWidth
                  name="company_location"
                  input={<Input />}
                  value={categorySettings && categorySettings.company_location}
                  onChange={handleChangeCategorySettings}
                >
                  <MenuItem value="">
                    <em>- None -</em>
                  </MenuItem>
                  <MenuItem
                    key={`company_location_${customer.id}`}
                    value={customer.id}
                  >
                    {customer.name}
                  </MenuItem>
                </Select>
              </Grid>
            )}
            {!categorySettings?.orderlist && (
              <Grid item xs={12} sm={true}>
                <InputLabel shrink id="orderlist_label">
                  Order Guide
                </InputLabel>
                <Select
                  fullWidth
                  name="orderlist"
                  input={<Input />}
                  value={categorySettings && categorySettings.orderlist}
                  disabled={
                    categorySettings.company_location === "" ||
                    !orderListSettings.length
                  }
                  onChange={handleChangeCategorySettings}
                >
                  <MenuItem value="">
                    <em>- None -</em>
                  </MenuItem>
                  {orderListSettings.map((item) => (
                    <MenuItem key={`orderlist_${item}`} value={item}>
                      {`Order Guide ${item}`}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sm={"auto"}
              style={{ justifyContent: "flex-end" }}
            >
              <Button
                /* style={{
              minWidth: "auto",
              marginTop: 10,
              padding: "6px 10px",
            }} */
                variant="contained"
                color="primary"
                onClick={handleClickCategoryAdd}
                disabled={
                  categorySettings.name === "" ||
                  categorySettings.orderlist === "" ||
                  categorySettings.company_location === ""
                }
              >
                Add category
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}></Grid>
        {orderList.map((orderListObj, olIndex) => (
          <Fragment key={`orderlist-${orderListObj.id}`}>
            <Grid item xs={12} sm={12}>
              <Typography
                component="h4"
                style={{ fontWeight: "bold", marginBottom: 16 }}
              >
                {`Categories in Order Guide ${orderListObj.company_location_name}`}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId={`orderlist-${orderListObj.id}`}>
                  {(provided) => (
                    <Grid
                      container
                      spacing={2}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {orderListObj.categories.map((category, catIndex) => (
                        <Draggable
                          key={`orderlist-${orderListObj.id}-cat-${catIndex}`}
                          draggableId={`orderlist-${orderListObj.id}-cat-${catIndex}`}
                          index={catIndex}
                        >
                          {(provided) => (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              sx={{
                                "&:hover": {
                                  backgroundColor: "#fff",
                                  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                                  transform: "translateY(-2px)",
                                },
                              }}
                              key={`orderlist-${orderListObj.id}-cat-${catIndex}`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                backgroundColor: "#fff",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                padding: "12px",
                                marginBottom: "8px",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.06)",
                                transition: "all 0.3s ease",
                              }}
                            >
                              <Grid
                                container
                                spacing={0}
                                alignItems="center"
                                sx={{ gap: "8px" }}
                              >
                                <Grid item xs={"auto"}>
                                  <IconButton aria-label="drag">
                                    <DragIndicatorIcon />
                                  </IconButton>
                                </Grid>
                                <Grid item xs={true}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    required={true}
                                    variant="standard"
                                    label="Name: "
                                    name={`category_name`}
                                    value={category && category.category_name}
                                    style={{
                                      padding: 8,
                                    }}
                                    onChange={(e) =>
                                      handleChangeCategory(
                                        e,
                                        orderListObj.id,
                                        catIndex,
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={"auto"}>
                                  <IconButton
                                    aria-label="delete"
                                    onClick={() => {
                                      setDeleteInfo({ olIndex, catIndex });
                                      toggleDeleteModal();
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Grid>
                  )}
                </Droppable>
              </DragDropContext>
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </div>
  );
};

export default OrderlistCategories;
